import { colorMapper, } from '@alfa-bank/newclick-helpers/utils/get-color-var/color-mapper';
const hasProperty = (record, key) => !!record[key];
const getColorWithTheme = (record, color, theme) => {
    const cssColorValue = record[color];
    const { type, value } = cssColorValue;
    if (type === 'WITHOUT_THEME') {
        return value;
    }
    return `${theme}-${value}`;
};
/**
 * Возвращает css переменную для цвета, либо сам цвет (если передан не через переменную)
 *
 * Примеры результатов:
 * - figma переменная: var(--color-light-bg-secondary)
 * - HEX: #444fff
 * - RGB: rgb(5, 5, 5)
 * - RGBA: rgba(5, 5, 5, 1)
 *
 * @param {Object} params Объект с параметрами
 * @param {Color} [params.color] Имя переменной в figma для цвета или HEX, RGB, RGBA
 * Пример: backgroundColorAccent, #ccc, rgb(5, 5, 5), rgba(5, 5, 5, 1)
 * @param {string} [params.prefix=''] Префикс для переменной css (для хоста передавать: h)
 * @param {'light' | 'dark'} [params.theme='light'] Тема (светлая или темная)
 * @deprecated Использовать getColorVar из https://git.moscow.alfaintra.net/projects/NEWCLICK/repos/newclick-helpers/browse/src/utils/get-color-var/get-color-var.ts
 */
export const getColorVar = ({ color, prefix = '', theme = 'light', }) => {
    if (!color) {
        return undefined;
    }
    if (hasProperty(colorMapper, color)) {
        const cssColor = getColorWithTheme(colorMapper, color, theme);
        const prefixWithDelimiter = prefix && `-${prefix}`;
        return `var(-${prefixWithDelimiter}-color-${cssColor})`;
    }
    return color;
};
